import AsyncStorage from '@react-native-async-storage/async-storage';
import { initDeviceConfigRequest, getDeviceConfigFailure, getDeviceConfigSuccess } from '../Reducers/deviceConfigReducer';
import { clientConfigPath, current_client_config, marketSegment } from '../../config/Constant';
import { updateDynamicStyle } from '../Reducers/dynamicStyleSheetReducer';



export const deviceConfig = () => {
  return async dispatch => {
    dispatch(initDeviceConfigRequest());

    try {
      const sessionToken = await AsyncStorage.getItem('sessionToken');
      const DeviceIdentifier = await AsyncStorage.getItem('DeviceIdentifier');

      const deviceConfigStoredData = await AsyncStorage.getItem('cachedDeviceConfigs');
      let deviceConfigParsedData = deviceConfigStoredData ? JSON.parse(deviceConfigStoredData) : {};
      const cachedDeviceConfig = deviceConfigParsedData[current_client_config] || "{}";


      let room = await AsyncStorage.getItem('room');
      let guestToken = await AsyncStorage.getItem('guestToken');

      let roomID = await AsyncStorage.getItem('roomID');


      let payload;
      if(guestToken || room || roomID){
        payload = {
          header: {
            sessionToken: sessionToken,
            deviceType: "app",
            cacheId: cachedDeviceConfig?.cacheId || null
          },
        }
      } else {
        payload = {
          header: {
            age: "36",
            gender: 'male',
            classificationType: marketSegment,
            deviceType: "app",
            cacheId: cachedDeviceConfig?.cacheId || null
          },
        } 
      }

      let rn = room || 'notLogin';
      clientConfigPath.put(`/deviceConfig?dId=${DeviceIdentifier}&rn=${rn}`, payload, { timeout: 30000 })
        .then(async response => {
          console.log('deviceConfig-action------>', response.data);
          if(response.data.cacheId ){
            deviceConfigParsedData[current_client_config] = response.data;
            AsyncStorage.setItem(`cachedDeviceConfigs`, JSON.stringify(deviceConfigParsedData));
          }
          dispatch(getDeviceConfigSuccess(response.data));
        })
        .catch(error => {
          console.log('deviceConfig-action------>', error);
          if(error.response?.status == 304){
            console.log("Device 304: ", cachedDeviceConfig)
            dispatch(getDeviceConfigSuccess(cachedDeviceConfig));
            return;
          }
          dispatch(getDeviceConfigFailure(error.message));
        });
    } catch (error) {
      console.error('Error fetching data from AsyncStorage', error);
      dispatch(getDeviceConfigFailure(error.message));
    }
  };
};
